import React from "react";
import InitialPropsContext from "../lib/models/initialPropsContext";
import PageNotFoundError from "../lib/pageNotFoundError";
import MagazinPage, { Props } from "../components/magazin/MagazinPage";
import PageProps from "../lib/models/pageProps";
export default function Page(props: Props) {
  return <MagazinPage {...props} />;
}

Page.getInitialProps = async ({
  api,
  query
}: InitialPropsContext): PageProps<Props> => {
  const activeTags =
    (query.tags && (query.tags as string).split(",")) || ([] as string[]);
  let q = {};
  if (activeTags.length > 0) {
    q = {
      tags: {
        eq: activeTags
      }
    };
  }
  const [
    tags,

    newsPage,
    news,

    portraitPage,
    portraits,

    eventPage,
    events,
    seo
  ] = await Promise.all([
    api.listTags().catch(() => ({ total: 0, items: [] })),

    api.loadMagazinNewsPage().catch(() => {
      throw new PageNotFoundError();
    }),
    api
      .listMagazinNews({
        order: "desc",
        orderBy: "date",
        limit: 3,
        ...q
      })
      .catch(() => ({ total: 0, items: [] })),

    api.loadMagazinPortraitPage().catch(() => {
      throw new PageNotFoundError();
    }),
    api
      .listMagazinPortraits({
        limit: 3,
        orderBy: "date",
        order: "desc",
        ...q
      })
      .catch(() => ({ total: 0, items: [] })),

    api.loadMagazinEventPage().catch(() => {
      throw new PageNotFoundError();
    }),
    api
      .listExternalEvents({
        offset: 0,
        limit: 10000,
        ...q
      })
      .catch(() => ({ total: 0, items: [] })),
    api.loadMagazinPage()
  ]);
  if (!newsPage || !portraitPage || !eventPage) throw new PageNotFoundError();

  const pageProps = {
    tags,
    activeTags,

    newsPage,
    news,

    portraitPage,
    portraits,

    eventPage,
    events,
    ...seo
  };

  let _pageImages;

  try {
    _pageImages = MagazinPage.getImages(pageProps);
  } catch (error) {
    console.error(error);
  }

  return {
    ...pageProps,
    _pageImages
  };
};
